import moment from 'moment';

export const END_DATE = "2024-12-05";
const today = moment();
const endDate = moment(END_DATE).add(1, 'days');;

export const ACTIVATE_COUNTDOWN = today.isBefore(endDate);
export const PROMOTIONAL_CODE = 'BFCM';
export const URL_UTM = 'https://www.talisis.com/membresias?utm_campaign=Cybermonday&utm_source=banner';